import React, { useMemo } from "react";

// Subtle, slow-falling olive leaves particle layer
export default function OliveLeaves({ count = 12 }) {
  const leaves = useMemo(() =>
    Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 12,
      duration: 14 + Math.random() * 12,
      size: 12 + Math.random() * 16,
      rotate: Math.random() * 360,
    })), [count]);

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {leaves.map((l) => (
        <svg
          key={l.id}
          className="absolute animate-fall"
          style={{
            left: `${l.left}%`,
            width: l.size, height: l.size,
            animationDelay: `${l.delay}s`,
            animationDuration: `${l.duration}s`,
            transform: `rotate(${l.rotate}deg)`,
          }}
          viewBox="0 0 24 24" fill="none"
        >
          <path d="M12 2C7 6 4 11 4 16c0 3 2 6 8 6s8-3 8-6c0-5-3-10-8-14z"
            fill="#6B7F3A" opacity="0.5" />
          <path d="M12 4v16" stroke="#4A5D23" strokeWidth="0.8" opacity="0.6" />
        </svg>
      ))}
    </div>
  );
}
